import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=39752f5b&scoped=true&"
import script from "./FilesTable.vue?vue&type=script&lang=ts&"
export * from "./FilesTable.vue?vue&type=script&lang=ts&"
import style0 from "./FilesTable.vue?vue&type=style&index=0&id=39752f5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39752f5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSimpleTable,VTooltip})
